import React from "react";

const Home = () => {
  return <div>Main Landing</div>;
};

export default Home;
